'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ModalDialog = require('./ModalDialog.jsx');

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoggedOutView = function (_React$Component) {
  _inherits(LoggedOutView, _React$Component);

  function LoggedOutView() {
    _classCallCheck(this, LoggedOutView);

    var _this = _possibleConstructorReturn(this, (LoggedOutView.__proto__ || Object.getPrototypeOf(LoggedOutView)).call(this));

    _this.state = { modal: null };
    _this.showLogin = _this.showLogin.bind(_this);
    _this.showSignup = _this.showSignup.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    return _this;
  }

  _createClass(LoggedOutView, [{
    key: 'showLogin',
    value: function showLogin() {
      this.setState({ modal: 'login' });
    }
  }, {
    key: 'showSignup',
    value: function showSignup() {
      this.setState({ modal: 'signup' });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.setState({ modal: '' });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.modal == 'login') {
        return _react2.default.createElement(LoginForm, {
          visible: true,
          didAuthenticate: this.props.didAuthenticate,
          onClose: this.closeModal });
      } else if (this.state.modal == 'signup') {
        return _react2.default.createElement(SignupForm, {
          visible: true,
          didAuthenticate: this.props.didAuthenticate,
          onClose: this.closeModal });
      } else {
        return _react2.default.createElement(Welcome, {
          onLoginClick: this.showLogin,
          onSignupClick: this.showSignup });
      }
    }
  }]);

  return LoggedOutView;
}(_react2.default.Component);

exports.default = LoggedOutView;

var Welcome = function (_React$Component2) {
  _inherits(Welcome, _React$Component2);

  function Welcome() {
    _classCallCheck(this, Welcome);

    return _possibleConstructorReturn(this, (Welcome.__proto__ || Object.getPrototypeOf(Welcome)).apply(this, arguments));
  }

  _createClass(Welcome, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'welcome inner' },
        _react2.default.createElement(
          'h1',
          null,
          'Calorie Counter'
        ),
        _react2.default.createElement(
          'button',
          { onClick: this.props.onLoginClick },
          'Log In'
        ),
        _react2.default.createElement(
          'button',
          { onClick: this.props.onSignupClick },
          'Sign Up'
        )
      );
    }
  }]);

  return Welcome;
}(_react2.default.Component);

var LoginForm = function (_React$Component3) {
  _inherits(LoginForm, _React$Component3);

  function LoginForm() {
    _classCallCheck(this, LoginForm);

    var _this3 = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this));

    _this3.state = {
      email: '',
      password: '',
      error: null
    };
    _this3.updateState = _this3.updateState.bind(_this3);
    _this3.handleSubmit = _this3.handleSubmit.bind(_this3);
    return _this3;
  }

  _createClass(LoginForm, [{
    key: 'updateState',
    value: function updateState(event) {
      var _setState;

      var name = event.target.name;
      var value = event.target.value;
      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'error', null), _setState));
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      var _this4 = this;

      event.preventDefault();
      _client2.default.authenticate({
        type: 'local',
        email: this.state.email,
        password: this.state.password
      }).then(function (res) {
        console.log('Authenticated!', res);
        _this4.props.didAuthenticate(res.data);
      }).catch(function (error) {
        console.error('Error authenticating!', error);
        _this4.setState({
          error: error.toString()
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _ModalDialog2.default,
        { visible: this.props.visible, onClose: this.props.onClose },
        _react2.default.createElement(
          'form',
          { onSubmit: this.handleSubmit },
          _react2.default.createElement('input', { type: 'email',
            name: 'email',
            autoFocus: true,
            placeholder: 'Email address',
            onChange: this.updateState
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement('input', { type: 'password',
            name: 'password',
            placeholder: 'Password',
            onChange: this.updateState
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement('input', { type: 'submit',
            value: 'Log In'
          }),
          _react2.default.createElement(
            'div',
            { className: 'error' },
            this.state.error
          )
        )
      );
    }
  }]);

  return LoginForm;
}(_react2.default.Component);

var SignupForm = function (_React$Component4) {
  _inherits(SignupForm, _React$Component4);

  function SignupForm() {
    _classCallCheck(this, SignupForm);

    var _this5 = _possibleConstructorReturn(this, (SignupForm.__proto__ || Object.getPrototypeOf(SignupForm)).call(this));

    _this5.state = {
      email: '',
      password: '',
      goal: 0,
      error: null
    };
    _this5.updateState = _this5.updateState.bind(_this5);
    _this5.handleSubmit = _this5.handleSubmit.bind(_this5);
    return _this5;
  }

  _createClass(SignupForm, [{
    key: 'updateState',
    value: function updateState(event) {
      var _setState2;

      var name = event.target.name;
      var value = event.target.value;
      this.setState((_setState2 = {}, _defineProperty(_setState2, name, value), _defineProperty(_setState2, 'error', null), _setState2));
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      var _this6 = this;

      event.preventDefault();
      var usersService = _client2.default.service('users');
      usersService.create(this.state).then(function (result) {
        console.log(result);
        return _client2.default.authenticate({
          type: 'local',
          email: _this6.state.email,
          password: _this6.state.password
        });
      }).then(function (res) {
        console.log('Authenticated!', res);
        _this6.props.didAuthenticate(res.data);
      }).catch(function (error) {
        console.error('Error authenticating!', error);
        _this6.setState({
          error: error.toString()
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _ModalDialog2.default,
        { visible: this.props.visible, onClose: this.props.onClose },
        _react2.default.createElement(
          'form',
          { onSubmit: this.handleSubmit },
          _react2.default.createElement('input', { type: 'email',
            name: 'email',
            autoFocus: true,
            placeholder: 'Email address',
            onChange: this.updateState
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement('input', { type: 'password',
            name: 'password',
            placeholder: 'Password',
            onChange: this.updateState
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement('input', { type: 'number',
            name: 'goal',
            min: '0',
            max: '100000',
            placeholder: 'Goal',
            onChange: this.updateState
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement('input', { type: 'submit',
            value: 'Sign Up'
          }),
          _react2.default.createElement(
            'div',
            { className: 'error' },
            this.state.error
          )
        )
      );
    }
  }]);

  return SignupForm;
}(_react2.default.Component);


//////////////////
// WEBPACK FOOTER
// ./client/components/LoggedOutView.jsx
// module id = 217
// module chunks = 0